/* OFFGRD compact video row.
 *
 * All three clips loop together while the row is on screen. Unlike the
 * homepage carousel there is no advance logic — this is a small supporting
 * element, so it stays simple.
 *
 * Not hidden behind prefers-reduced-motion: that setting should stop
 * automatic motion, not remove the footage. Those users get native controls.
 */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function paintFirstFrame(video) {
    if (video.readyState >= 2) return;
    try {
      video.currentTime = 0.1;
    } catch (e) {
      /* seeking before metadata throws in older Safari — harmless */
    }
  }

  function init(root) {
    var videos = root.querySelectorAll('.offgrd-vr__video');
    if (!videos.length) return;

    Array.prototype.forEach.call(videos, function (v) {
      v.addEventListener('loadedmetadata', function () { paintFirstFrame(v); });
      if (reduce) v.controls = true;
    });

    if (reduce) return;

    function playAll() {
      Array.prototype.forEach.call(videos, function (v) {
        var p = v.play();
        if (p && p.catch) {
          p.catch(function () {
            v.controls = true;
            paintFirstFrame(v);
          });
        }
      });
    }

    function pauseAll() {
      Array.prototype.forEach.call(videos, function (v) {
        if (!v.paused) v.pause();
      });
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) playAll();
            else pauseAll();
          });
        },
        { rootMargin: '150px 0px', threshold: 0.2 }
      );
      io.observe(root);
    } else {
      playAll();
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) pauseAll();
    });
  }

  function boot() {
    document.querySelectorAll('[data-offgrd-video-row]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-offgrd-video-row]');
    if (el) init(el);
  });
})();
